module.exports = __webpack_public_path__ + "img/essentials-for-living.f5704d8.jpg";